export default [
    '/login',
    '/register',
    '/forget',
    '/info/spot',
    '/info/any-extract',
    '/info/cent-purchasing',
    '/info/promotion',
    '/info/promotion/detail',
    '/info/ad'
]



// WEBPACK FOOTER //
// ./src/assets/js/whitelist.js